// @see StyledButtonChildren.js for the secondary underline style.

import { css } from 'styled-components';

import type { ButtonStyleProps } from '/shared/components/widgets/button/buttonTypes';

import Colours from '/shared/styled/Colours';

export default function secondaryStyle({ $secondary, $inverted, color, disabled, theme }: ButtonStyleProps) {
  if ($secondary) {
    return css`
      font-size: 1rem;
      color: ${color || Colours.black};
      background: transparent;
      border-radius: 0;
      font-weight: 400;
      ${
        !disabled &&
        css`
        &:hover,
        &:focus,
        &:active,
        &:visited:hover,
        &:visited:focus,
        &:visited:active {
          color: ${Colours.green};
        }
      `
      }
      ${
        $inverted &&
        css`
        color: ${Colours.white};
      `
      }
    `;
  }
}
